import SummaryItem from 'components/atoms/SummaryItem'
import * as React from 'react'
import styled from 'styled-components'
import I18n from '../../../core/i18n'

interface IProps {
  data: any
}

const Summary: React.VFC<IProps> = ({ data }) => {
  // データ受け取って生成するようにする
  return (
    <SummaryItems>
      {Object.keys(data).map(key => (
        <SummaryItem key={key} title={I18n.t(`sales.${key}`)} value={`${data[key]}%`} />
      ))}
    </SummaryItems>
  )
}

const SummaryItems = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 570px;
`

export default Summary
